<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :btnsave="true"
    :title="
      lokasi && lokasi.lokasi_presensi_id
        ? 'Ubah Lokasi Presensi'
        : 'Tambah Lokasi Presensi'
    "
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row wrap>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                <label class="caption mb-2">Label Lokasi Presensi</label>
                <v-text-field
                  autofocus
                  dense
                  single-line
                  outlined
                  label="Label Lokasi Presensi"
                  id="Nama"
                  key="lokasi-input"
                  name="Nama"
                  v-model="lokasi.nama"
                  hint="Masukkan Label Lokasi Presensi, Contoh: Nama Instansi"
                  data-vv-name="nama"
                  data-vv-as="Nama"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.nama')"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                v-if="showAlamatExisting"
                class="py-0"
              >
                <label class="caption mb-2">Letak Presensi</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  label="Letak Presensi"
                  id="Lokasi"
                  key="alamat-input"
                  name="Lokasi"
                  v-model="lokasi.alamat"
                  hint="Ubah Pointing Lokasi Presensi, dengan Klik Tombol Ubah Lokasi di Bawah Ini"
                  data-vv-name="alamat"
                  data-vv-as="Lokasi"
                  readonly
                  v-validate="'required'"
                  :error-messages="errors.collect('form.alamat')"
                ></v-text-field>
                <br />
                <v-btn
                  depressed
                  class="text-right"
                  color="primary white--text"
                  @click="reloadLokasi()"
                >
                  <v-icon small class="mr-3">mdi-pencil</v-icon>Ubah Lokasi
                </v-btn>
              </v-col>

              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                v-show="$consts.GMAP_KEY && showMap"
              >
                <v-slider
                  v-model="lokasi.radius"
                  min="0"
                  :max="maxRadius"
                  :label="'Toleransi Radius Presensi (' + lokasi.radius + 'm)'"
                  thumb-label
                ></v-slider>
              </v-col>

              <v-col class="grey lighten-4"
                cols="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                v-show="$consts.GMAP_KEY && showMap"
              >
                <PetaLokasi
                  ref="mymap"
                  :mapUpdated="mapUpdated"
                  @changeKordinat="changeKordinat"
                  @changeLocation="changeLocation"
                  @changePathAreaPresensi="changePathAreaPresensi"
                  @setAlamat="setAlamat"
                ></PetaLokasi>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import PetaLokasi from "./PetaLokasi.vue";
export default {
  components: {
    VueGoogleAutocomplete,
    PetaLokasi
  },
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      showMap: false,
      showAlamatExisting: false,
      pathAreaPresensi: [],
      lokasi: {},
      center: {},
      mapUpdated: 0,
      defLokasi: {
        alamat: null,
        nama: null
      }
    };
  },
  computed: {
    maxRadius() {
      return ['ORG-XZG37I'].includes(this.current_organisasi.kode_organisasi) ? 1000 : 100
    }
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.$validator.reset();
      this.lokasi = obj
        ? {
            ...obj,
            ...(this.showMap = false),
            ...(this.showAlamatExisting = true)
          }
        : {
            ...this.defLokasi,
            ...(this.showMap = true),
            ...(this.showAlamatExisting = false)
          };
      this.mapUpdated = Math.floor(Date.now() / 1000) + Math.random();
      return this.$refs.dlg.open();
    },
    reloadLokasi() {
      this.showMap = true;
      this.$refs.mymap.setUlang(this.lokasi);
    },
    changeLocation(lokasi, radius) {
      this.currentPlace = { ...lokasi };
      this.lokasi.alamat = lokasi.route
        ? lokasi.route
        : "" + "," + lokasi.street_number
        ? lokasi.street_number
        : "" + "," + lokasi.administrative_area_level_1
        ? lokasi.administrative_area_level_1
        : "";
      this.lokasi.latitude = lokasi.latitude;
      this.lokasi.longitude = lokasi.longitude;
      this.lokasi.radius = radius;
    },
    changeKordinat(latLong) {
      this.lokasi.latitude = latLong[0].position.lat;
      this.lokasi.longitude = latLong[0].position.lng;
    },
    changePathAreaPresensi(path) {
      this.pathAreaPresensi = [...path];
      this.lokasi.area = [...path];
    },
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          if (!this.lokasi.alamat) {
            this.$error("Anda belum menentukan lokasi pada peta");
            return Promise.reject();
          }
        })
        .then(() => {
          return this.$store.dispatch("organisasi/formLokasi", {
            organisasi_id: this.organisasi_id,
            obj: this.lokasi
          });
        })
        .then(res => {
          this.$refs.dlg.resolve();
          return res;
        })
        .catch(e => e);
    },
    setAlamat(value) {
      if (value) {
        this.$set(this.lokasi, "alamat", value[0]["formatted_address"]);
      }
    }
  }
};
</script>
